.select-listbox-container {
  position: relative;
}

.select-listbox__wrapper {
  border-radius: 0.25rem;
  box-shadow: 0 0 0.25rem 0 rgba(0 0 0 / 25%);
  height: auto;
  overflow: hidden;
  position: fixed;
  width: auto;
  z-index: 20;
}

.select-listbox-trigger {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-400);
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  font: inherit;
  justify-content: space-between;
  line-height: inherit;
  overflow: hidden;
  padding: 0.4rem 2rem 0.4rem 1rem;
  width: 100%;
}

.select-listbox-trigger--default {
  padding: 0.75rem 2rem 0.75rem 1rem;
}

.select-listbox-trigger--small {
  padding: 0.4rem 2rem 0.4rem 1rem;
}

.select-listbox-trigger--medium {
  height: 2.75rem;
  padding: 0.5rem 2rem 0.5rem 1rem;
}

.select-listbox-trigger-label {
  min-height: 0.65rem;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.select-listbox__wrapper--align-right {
  right: 0;
}

.select-listbox-trigger--bold {
  font-weight: var(--semibold);
}

.select-listbox-trigger--pill {
  border-radius: 6.25rem;
  padding: 0.5rem 1.5rem;
}

.select-listbox-trigger--pillLeft {
  border-radius: 6.25rem 0 0 6.25rem;
  padding-left: 1.5rem;
}

.select-listbox-trigger--pillRight {
  border-radius: 0 6.25rem 6.25rem 0;
  padding-right: 1.25rem;
}

.select-listbox-trigger--darkBorder {
  border-color: var(--color-uva-black);
}

.select-listbox-trigger--roundedLeft {
  border-radius: 0.25rem 0 0 0.25rem;
}

.select-listbox-trigger--roundedRight {
  border-radius: 0 0.25rem 0.25rem 0;
}

.select-listbox-trigger:focus-visible {
  background-color: var(--color-grey-300);
  outline: 1px solid var(--color-grey-700);
}

.select-listbox-trigger:focus-visible,
.select-listbox-trigger:hover {
  background-color: var(--color-grey-300);
}

.select-listbox-trigger--noborder {
  border: none;
}

.select-listbox-trigger--not-valid {
  border-color: var(--color-red-600);
}

.select-listbox-trigger--pillLeft + .select-listbox__wrapper {
  left: 1rem;
}

.select-listbox-trigger--pillRight + .select-listbox__wrapper--align-right {
  right: 1rem;
}

.select-listbox-trigger-icon {
  position: absolute;
  right: 0.875rem;
}

.select-listbox-trigger-icon--open {
  transform: rotate(180deg);
}

.select-listbox {
  background-color: var(--color-uva-white);
  list-style: none;
  margin: 0;
  min-width: 100%;
  overflow-y: auto;
  padding: 4px;
  width: fit-content;
}

.select-listbox-option {
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  position: relative;
  user-select: none;
}

/* keyword active is styling that cover both on mouse:hover and keyboard:focus */

.select-listbox-option--active,
.select-listbox-option:hover {
  background-color: var(--color-grey-300);
  box-shadow: 0 0 0 1px var(--color-uva-white);
}

.select-listbox-option[aria-selected="true"] {
  font-weight: var(--semibold);
}

.select-listbox-divider {
  background-color: var(--color-grey-400);
  height: 1px;
  margin: 1px -0.25rem;
  /* minus side margin to bleed over listbox padding */
}
